








import {Component, Prop, Vue} from 'vue-property-decorator'

@Component
export default class ModalBaseOverlay extends Vue {

  @Prop() readonly onClose?: Function

}
